import React from 'react';
import { Path } from 'react-hook-form';
//
import FormComplete from '../../componets/form/formComplete';
import { ImperativeHandleAccessedByParentComponent } from '../../componets/interfaces/formProps';
import { FormInputProps } from '../../componets/form/formInterfaces';

interface IFormInput {
    company: {
        id: string;
        description: string;
    };
    permission: {
        id: string;
        description: string;
    };
    list: boolean;
    create: boolean;
    update: boolean;
    delete: boolean;
    execute: boolean;
}

interface IRight {
    list: boolean;
    create: boolean;
    update: boolean;
    delete: boolean;
    execute: boolean;
}

const Form: React.FC<{ settings: any }> = props => {
    const { settings } = props;

    const refForm =
        React.useRef<ImperativeHandleAccessedByParentComponent<IFormInput>>(
            null,
        );

    const inputsForm = React.useMemo<FormInputProps<IFormInput>[]>(
        () => [
            {
                typeInput: 'text',
                name: 'description',
                control: null,
                label: 'Descrição',
                md: 6,
                xs: 12,
                rules: {
                    required: true,
                },
                messagesError: [
                    {
                        type: 'required',
                        message: 'O campo descrição é obrigatório',
                    },
                ],
            },
            {
                typeInput: 'autocomplete',
                name: 'permission',
                control: null,
                label: 'Permissão',
                md: 6,
                xs: 12,
                rules: {
                    required: true,
                },
                messagesError: [
                    {
                        type: 'required',
                        message: 'O campo é obrigatório',
                    },
                ],
                query: (value: string) => `permission?description=${value}`,
                activeDebounce: true,
            },
            {
                typeInput: 'autocomplete',
                name: 'company',
                control: null,
                label: 'Empresa',
                md: 6,
                xs: 12,
                rules: {
                    required: true,
                },
                messagesError: [
                    {
                        type: 'required',
                        message: 'O campo é obrigatório',
                    },
                ],
                query: (value: string) => `company?description=${value}`,
                activeDebounce: true,
            },
            {
                typeInput: 'checkbox',
                name: 'list',
                control: null,
                label: 'Listar',
                md: 1,
                xs: 12,
            },
            {
                typeInput: 'checkbox',
                name: 'create',
                control: null,
                label: 'Criar',
                md: 1,
                xs: 12,
            },
            {
                typeInput: 'checkbox',
                name: 'update',
                control: null,
                label: 'Atualizar',
                md: 1,
                xs: 12,
            },
            {
                typeInput: 'checkbox',
                name: 'delete',
                control: null,
                label: 'Excluir',
                md: 1,
                xs: 12,
            },
            {
                typeInput: 'checkbox',
                name: 'execute',
                control: null,
                label: 'Executar',
                md: 1,
                xs: 12,
            },
        ],
        [],
    );

    const defaultValues: IRight = {
        list: false,
        create: false,
        update: false,
        delete: false,
        execute: false,
    };

    const implSetValueData = React.useCallback((data: any) => {
        for (const input of inputsForm) {
            if (defaultValues[input.name as keyof IRight]) {
                defaultValues[input.name as keyof IRight] = data[input.name];
                continue;
            }
            refForm?.current?.setValue(
                input.name as Path<IFormInput>,
                data[input.name],
            );
        }
    }, []);

    return (
        <FormComplete
            defaultValues={defaultValues}
            inputsForm={inputsForm}
            ref={refForm}
            settings={settings}
            implSetValueData={implSetValueData}
        />
    );
};

export default Form;
